import type { IApplication } from "@/models/applications";

type FileWithOwner = {
  id: number;
  personal_information?: { id: number } | null;
};

type DealLike = Pick<IApplication, "id" | "personal_information">;

export const buildDocumentEventBase = (
  file: FileWithOwner,
  deal: DealLike
) => ({
  file_id: file.id,
  deal_uuid: deal.id,
  user_id:
    file.personal_information?.id ?? deal.personal_information?.id ?? null,
});
